import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const AddIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><g clipPath="url(#clip0_6539_3190)"><path d="M21 3H7V17H21V3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M17 17V21H3V7H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M14 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></g></svg></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default AddIcon;